<template>
  <div id="app">
    <!-- <nav-bar class='navbar'></nav-bar> -->
    <transition name="fade-transform" mode="out-in">
      <router-view  v-if="isRouterAlive" />
    </transition>
  </div>
</template>

<script>
  export default {
    name: 'App',
    components: {
      navBar: () => import('./layout/navBar.vue'),
    },
    provide() {
      return {
        reload: this.reload
      };
    },
    data(){
      return{
        isRouterAlive: true
      }
    },
    methods:{
      reload() {
        this.isRouterAlive = false;
        this.$nextTick(function() {
          this.isRouterAlive = true;
        });
      },
    }
  }
</script>

<style>
  body,html{
    /* background: #f2f2f2; */
  }
  #app{
    min-height: 100vh;
    overflow-x: hidden;
  }
  /* 取消浏览器默认样式 */
  * {
    margin: 0;
    padding: 0;
    list-style: none;
    text-decoration: none;
    box-sizing: border-box;
    user-select: none;
    color: #666666;
    /* word-break: break-all; */
		font-family: '微软雅黑';
  }

  /* 设置默认pc宽度 */
  .container{
      width: 1200px;
      left: 0;
      right: 0;
      margin: auto;
      position: relative;
  }

  /* 设置文本省略号 */
  .one-line {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
    
    .two-line {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
    
    .three-line {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
    }
/* 弹性布局 */
  .rowFlex{
    display: flex;
    flex-direction: row;
  }
  
  .colFlex{
    display: flex;
    flex-direction: column;
  }
  
  .justifyFlex{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .jus_start_Flex{
    justify-content: flex-start;
  }
  
  .jus_end_Flex{
    justify-content: flex-end;
  }
  
  .align_start_Flex{
    align-items: flex-start;
  }
  
  .align_end_Flex{
    align-items: flex-end;
  }
 

 /* 页面进入动画 */
  .fade-transform-leave-active,
  .fade-transform-enter-active {
    transition: all .5s;
  }
  
  .fade-transform-enter {
    opacity: 0;
    transform: translateX(-50px);
  }
  
  .fade-transform-leave-to {
    opacity: 0;
    transform: translateX(50px);
  }
</style>



// WEBPACK FOOTER //
// src/App.vue